module.exports = __webpack_public_path__ + "0403320c05bbf02154f7762385a9b6b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00008EFF.png
// module id = 1685
// module chunks = 0